import { j as t } from "./jsx-runtime-DmTjM30f.mjs";
import { useState as u, useEffect as h } from "react";
import { I as x } from "./ic_arrowmore_fill-t069C13c.mjs";
import { c } from "./tw-cn-mXgPecoF.mjs";
import { D as j } from "./divider-DmNXvsxd.mjs";
const v = ({ title: i, content: d, disabled: a, open: n, showDivider: o, onClick: l }) => {
  const m = (f) => {
    if (a) {
      f.preventDefault();
      return;
    }
    l == null || l(f);
  };
  return /* @__PURE__ */ t.jsxs("div", { "aria-disabled": a, className: c("bg-static-white [&[open]>summary>svg]:rotate-180"), children: [
    /* @__PURE__ */ t.jsx(
      "h3",
      {
        className: c(
          "flex w-full cursor-pointer items-center gap-12",
          "active:bg-interaction-neutral-presshover-weak1 hover-never:bg-interaction-neutral-presshover-weak1",
          {
            "active:bg-static-white hover-never:bg-static-white": a
          }
        ),
        children: /* @__PURE__ */ t.jsxs(
          "button",
          {
            "aria-expanded": n,
            className: c("flex min-h-48 w-full items-center justify-between gap-6", {
              "cursor-not-allowed text-interaction-neutral-disable-main": a
            }),
            onClick: m,
            type: "button",
            children: [
              /* @__PURE__ */ t.jsx("span", { className: "flex gap-6 typography-body-14-bold", children: i }),
              /* @__PURE__ */ t.jsx(
                x,
                {
                  className: c("size-16", { "rotate-180": n, "text-interaction-neutral-disable-main": a })
                }
              )
            ]
          }
        )
      }
    ),
    !!o && /* @__PURE__ */ t.jsx(j, {}),
    /* @__PURE__ */ t.jsx("div", { className: c("hidden", { block: n }), children: d })
  ] });
}, g = ({ items: i, className: d, showDivider: a, multiple: n = !1, onClick: o }) => {
  const [l, m] = u([]), f = (r, e) => {
    m((s) => n ? s.includes(e) ? s.filter((p) => p !== e) : [...s, e] : s.includes(e) ? [] : [e]), o == null || o(r, e);
  };
  return h(() => {
    if (n) {
      const r = i.map((e, s) => e.initialOpen ? s : -1).filter((e) => e !== -1);
      m(r);
    } else {
      const r = i.findIndex((e) => e.initialOpen);
      r !== -1 && m([r]);
    }
  }, [i, n]), /* @__PURE__ */ t.jsx("div", { className: c("flex flex-col", d), children: i.map((r, e) => /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
    v,
    {
      ...r,
      onClick: (s) => {
        f(s, e);
      },
      open: l.includes(e),
      showDivider: a
    }
  ) }, `item_${e.toString()}`)) });
};
g.displayName = "NDS.Accordion";
export {
  v as A,
  g as a
};
